export enum PERMISSIONS_TYPES {
  DELETE_CUSTOMER = "delete_subject",
  ADMIN_USER = "admin_user",
  EDIT_SETTINGS = "edit_settings"
}

export const MLRO_GROUP_KEY = "MLRO";
export const COMPLIANCE_OFFICER_GROUP_KEY = "COMPLIANCE_OFFICER";
